module.exports = __webpack_public_path__ + "img/TN.9b2dd41d.svg";